export const getHasOilTreatmentText = (hasOilTreatment) => {
  if (hasOilTreatment === null) return '未設定'
  return hasOilTreatment ? 'あり' : 'なし'
}

export const getLaundryTypeTextByMap = (laundryType, laundryTypeMap) => {
  if (laundryType === null) return '未設定'
  const laundryTypeData = (laundryTypeMap || {})[laundryType]
  return laundryTypeData ? laundryTypeData.val : '未設定'
}
